"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var taskTemplates;
        (function (taskTemplates) {
            var index;
            (function (index) {
                class InitArgs {
                    constructor() {
                        this.organiseTaskTemplates = appn.emptyString;
                        this.dateFilter = appn.emptyString;
                        this.taskTemplatesIndex = appn.emptyString;
                        this.taskTemplatesSettings = appn.emptyString;
                    }
                }
                let _initArgs;
                let _dataTable;
                function init(args) {
                    _initArgs = args;
                    appn.folderFilter.init(_initArgs.taskTemplatesIndex);
                    appn.dateFilter.init(_initArgs.dateFilter);
                    createDataTable();
                }
                index.init = init;
                function createDataTable() {
                    _dataTable = appn.dataTable.create('.dataTable', {
                        sDom: appn.dataTable.genSDom(1, 0, 4),
                        sAjaxSource: 'TaskTemplates/DataTable',
                        fnServerData: function (data) {
                            data.push(appn.dataTable.getStateOrDefault('sCustom_0', $('#sCustom_0').prop('checked')), { name: 'sCustom_1', value: appn.folderFilter.getStateOrDefault().value }, { name: 'sCustom_2', value: appn.dateFilter.getStateOrDefaultAsString() });
                        },
                        aaSorting: [[1, 'asc']],
                        aoColumns: [
                            { bSortable: false, sWidth: '3%' },
                            { bSortable: true, sWidth: '50%' },
                            { bSortable: true, sWidth: '20%' },
                            { bSortable: true, sWidth: '25%' }
                        ],
                        fnInitComplete: function () {
                            appn.actionButtons.renderNavbarActionButtons([
                                { buttonId: 'organiseBtn', buttonType: 'Organise', isDataTableToggleBtn: true },
                            ], appn.requestUser.isUserOrHigher, true);
                            appn.actionButtons.renderNavbarActionButtons([
                                { buttonId: 'addnew', buttonType: 'AddNew' }
                            ], appn.requestUser.isUserOrHigher);
                            $('#addnew').click(function (e) {
                                e.preventDefault();
                                appn.location.navTo(_initArgs.taskTemplatesSettings, [
                                    { name: 'Id', value: appn.emptyGuid },
                                    { name: 'folderId', value: appn.folderFilter.selectedFolderId }
                                ]);
                            });
                            appn.sideFilterAndContent.appendShowButton($('#DataTables_Table_0_filter'));
                            $('#organiseBtn').click(function () {
                                appn.folderFilter.showDialog($(this), _initArgs.organiseTaskTemplates);
                            });
                            appn.dataTable.addSearchPlaceholder(T('Filter results where Task Template <b>Name, User First Name, Last Name or External Id</b> contains a keyword typed in here.'));
                            appn.saveMeState.init(function () {
                                _dataTable.fnDraw(false);
                            }, function () {
                                _dataTable.fnDraw(false);
                            }, '.dataTables_filter');
                        }
                    });
                }
            })(index = taskTemplates.index || (taskTemplates.index = {}));
        })(taskTemplates = views.taskTemplates || (views.taskTemplates = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
